import {
  Drawer,
  DrawerBackHeader,
  DrawerBody,
  DrawerHeader,
  useDrawer
} from '@cat-ecom/pcc-components';
import { CatHeading, CatSkeleton } from 'components/blocks-components';
import styles from '../product-availability.module.scss';
import { useTranslations } from 'next-intl';
import { useLocationQuery } from 'services/locations/useLocationQuery';
import { useEsiteCtx } from 'services/esite/context';
import ContactDealerPopoverContent from 'components/contact-your-dealer/contact-dealer-popover-content/contact-dealer-popover-content';
import { Store } from 'components/availability-wrapper/dealer-other-branches/types';
import { generateContactUrl } from 'components/dealer-locator/dealer-locator-content/utils';
import { useProductDetailPageContext } from 'app/[lang]/[esite]/(core)/product/[product]/context/product-detail';

export type ContactDealerDrawerProps = {
  contactDealerDrawer: ReturnType<typeof useDrawer>;
  store: Store;
  closeAvailabilityDrawer?: () => void;
  locale?: string;
};
const ContactDealerDrawer = ({
  contactDealerDrawer,
  closeAvailabilityDrawer,
  store,
  locale
}: ContactDealerDrawerProps) => {
  const t = useTranslations();
  const { catalogId, langId } = useEsiteCtx();
  const { isCustomerSupportEnabled, helpCenterContactSupportUrl } =
    useProductDetailPageContext();

  const returnContactUrl = generateContactUrl(catalogId, langId);
  const { data: locationData, isPending: isLocationDataPending } =
    useLocationQuery(store, contactDealerDrawer?.isDrawerOpen, false);
  const address = {
    ...locationData?.address,
    isCustomerSupportEnabled,
    helpCenterOldFaqLink: returnContactUrl(store?.storeId),
    helpCenterContactSupportUrl
  };
  return (
    <Drawer
      {...contactDealerDrawer.drawerProps}
      onBlDrawerClose={closeAvailabilityDrawer}
      className={styles['contact-dealer-content']}
      data-testid="contact-dealer-drawer"
      disableBackdropClick
    >
      <DrawerBackHeader handleClose={contactDealerDrawer.closeDrawer}>
        <DrawerHeader>
          <CatHeading variant="title-sm">{t('CONTACT_YOUR_DEALER')}</CatHeading>
        </DrawerHeader>
      </DrawerBackHeader>
      <DrawerBody>
        {isLocationDataPending ? (
          <div className="cat-u-margin-top-lg px-1">
            <CatSkeleton
              width="50%"
              className="cat-u-display-block cat-u-margin-bottom-sm"
            />
            <CatSkeleton
              width="50%"
              className="cat-u-display-block cat-u-margin-bottom-sm"
            />
            <CatSkeleton
              width="50%"
              size="lg"
              className="cat-u-display-block cat-u-margin-bottom-lg"
            />
            <CatSkeleton
              width="50%"
              size="sm"
              className="cat-u-display-block cat-u-margin-bottom-lg"
            />
          </div>
        ) : (
          <ContactDealerPopoverContent
            dealerAddress={address}
            locale={locale}
          />
        )}
      </DrawerBody>
    </Drawer>
  );
};

export default ContactDealerDrawer;
